import { api } from "..";
import { QueryProps } from "@/types/Api";
import { ChatContactsApiResponse } from "./types";

export const getChatContacts = async (
  props: QueryProps
): Promise<ChatContactsApiResponse> => {
  const res = await api.client.get("/chats/contacts", {
    signal: props.signal,
  });
  return res.data;
};
